/* eslint-disable react/require-default-props */
import React from 'react';
import {View, ViewStyle} from 'react-native';

import {styles} from './Gutter.style';

export const Gutter = ({
  children = null,
  style: styleProp = {},
  size = 20,
  accessible = false,
}: {
  children?: React.ReactNode;
  style?: ViewStyle | ViewStyle[];
  size?: number;
  accessible?: boolean;
} = {}) => {
  const style = [styles.base, {paddingHorizontal: size}, styleProp];

  return (
    <View style={style} accessible={accessible}>
      {children}
    </View>
  );
};

export default Gutter;
